<template>
	<div class="forum-board-admin">
		<nav class="forum-board-nav">
			<button
				type="button"
				class="forum-back-btn"
				title="Back to boards"
				aria-label="Back to boards"
				@click="goBack"
			>
				<i class="fas fa-arrow-left"></i>
			</button>
			<span class="forum-back-label">{{ boardLabel }}</span>
		</nav>

		<DiscussionBoardView :scope="scope" :entity-id="entityId" />
	</div>
</template>

<script>
import DiscussionBoardView from "../../components/Forum/DiscussionBoardView.vue";
import { BoardScope } from "../../constants/forum";

export default {
	name: "ForumBoardAdmin",
	components: { DiscussionBoardView },
	computed: {
		scope() {
			return this.$route.params.scope || BoardScope.Global;
		},
		entityId() {
			const rawEntityId = this.$route.params.entityId;
			return rawEntityId != null && rawEntityId !== "" ? Number(rawEntityId) : null;
		},
		boardLabel() {
			if (this.equalsIgnoreCase(this.scope, BoardScope.Global)) return "Global board";
			if (this.equalsIgnoreCase(this.scope, BoardScope.ProductVariant)) {
				return "Discussion Boards";
			}
			return "Board";
		},
	},
	methods: {
		equalsIgnoreCase(a, b) {
			if (a == null || b == null) return a === b;
			return String(a).toLowerCase() === String(b).toLowerCase();
		},
		goBack() {
			this.$router.push({ name: "ForumManagement" });
		},
	},
};
</script>

<style scoped>
.forum-board-admin {
	background-color: #f5f5f5;
	min-height: calc(100svh - var(--header-height));
}

.forum-board-nav {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	padding: 14px 24px 6px;
}

.forum-back-btn {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: #ffffff;
	border: 1px solid #ececec;
	color: #0f0f0f;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 13px;
	font-family: inherit;
	transition: background-color 0.15s ease, border-color 0.15s ease,
	            box-shadow 0.15s ease, transform 0.1s ease;
}
.forum-back-btn:hover {
	background: #f2f2f2;
	border-color: #d0d0d0;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}
.forum-back-btn:active { transform: scale(0.95); }

.forum-back-label {
	font-size: 13px;
	font-weight: 500;
	color: #606060;
	letter-spacing: 0.02em;
}
</style>
